import type { Project } from "../api/types";
import type { ReviewTally } from "../lib/reportStore";
import { deriveProjectStatus } from "../lib/projectStatus";

// The project status chip, shown on the project list and the project header.
// A live job takes precedence (stage + progress); otherwise the status is
// DERIVED from current facts (see deriveProjectStatus), plus spec/pickup badges.
// Pass `tally` (the review counts) on the project page so it can resolve
// "In review"/"Reviewed"; the list omits it and tops out at "Proofed".
export function ProjectStatusPill({
  p, tally, pickups,
}: { p: Project; tally?: ReviewTally | null; pickups?: number }) {
  if (p.active_job) {
    return (
      <span className="pill s-proofing" title={p.active_job.current_stage || ""}>
        <span className="spinner" style={{ width: 11, height: 11 }} />
        {p.active_job.job_type === "map_propose" ? "mapping" : "proofing"} ·{" "}
        {Math.round(p.active_job.progress_pct)}%
      </span>
    );
  }
  const d = deriveProjectStatus(p, { tally, pickups });
  return (
    <span className="status-cluster">
      <span className={`pill s-${d.key}`}>{d.label}</span>
      {d.badges.map((b, i) => (
        <span key={i} className="status-badge" title={b.title}>{b.icon} {b.label}</span>
      ))}
    </span>
  );
}
